import React from 'react';
import {
    FaTrashAlt
  } from "react-icons/fa"; 
import {
    Button,
    message,
    Popconfirm,
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function DeletePopupButton({ data }) {

    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ _id }) => {
            axios
                .delete(`/api/categories/${_id}`)
                .then(() =>  queryClient.invalidateQueries(['/api/categories/']))
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        }
    });

    const confirm = (e) => mutate(data);

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="Delete"
                description="Do you want to delete Yes or No?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <Button danger icon={<FaTrashAlt />} type='text' />
            </Popconfirm>
        </div>
    )
}
